if (!window.customElements.get("faq-item")) {
  // Globaler Event-Bus für die Kommunikation zwischen Accordion-Elementen
  const faqItemEventBus = new EventTarget();
  class FaqItem extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.getAttribute("section-id");
      this.isOpen = false;
      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");

      if (this.summary) {
        this.summary.addEventListener("click", () => this.toggle());
      }

      faqItemEventBus.addEventListener("faq-item-opened", (event) => {
        if (
          event.detail !== this &&
          this.isOpen &&
          event.detail.sectionId === this.sectionId
        ) {
          this.close();
        }
      });
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
        // Informiere andere Accordions, dass dieses geöffnet wurde
        faqItemEventBus.dispatchEvent(
          new CustomEvent("faq-item-opened", { detail: this })
        );
      }
    }

    open() {
      this.isOpen = true;
      this.details.setAttribute("open", "");
    }

    close() {
      this.isOpen = false;
      this.details.removeAttribute("open");
    }
  }
  window.customElements.define("faq-item", FaqItem);
}

if (!window.customElements.get("product-card-carousel")) {
  class ProductCardCarousel extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector(".product-card-carousel");
      this.customDots = this.querySelector(".ab-custom-dots");
      this.dots = this.customDots?.querySelectorAll(".dot");

      this.init();
    }

    init() {
      if (!this.carousel || !this.customDots || !this.dots) {
        return;
      }

      // Initialize first dot as active
      this.dots[0].classList.add("active");

      // Set up dot click handlers
      this.setupDotClickHandlers();

      // Listen to carousel change events
      this.setupCarouselEventListeners();
    }

    setActiveDot(index) {
      this.dots.forEach((dot) => dot.classList.remove("active"));
      const dotIndex = index % 3;
      this.dots[dotIndex].classList.add("active");
    }

    setupDotClickHandlers() {
      this.dots.forEach((dot, dotIndex) => {
        dot.addEventListener("click", () => {
          const currentIndex = this.carousel.selectedIndex;
          const groupStart = Math.floor(currentIndex / 3) * 3;
          const targetIndex = groupStart + dotIndex;

          if (targetIndex < this.carousel.cells.length) {
            this.carousel.select(targetIndex);
          }
        });
      });
    }

    setupCarouselEventListeners() {
      // Listen to the carousel's change event
      this.carousel.addEventListener("carousel:change", (event) => {
        const newIndex = event.detail.index;
        this.setActiveDot(newIndex);
      });

      // Also listen to the scroll event for immediate feedback
      this.carousel.addEventListener("scroll", () => {
        // Use the carousel's built-in selectedIndex getter
        const currentIndex = this.carousel.selectedIndex;
        this.setActiveDot(currentIndex);
      });
    }
  }
  window.customElements.define("product-card-carousel", ProductCardCarousel);
}
